module.exports = __webpack_public_path__ + "static/fonts/nucleo-icons.b0dc05d.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/nucleo-icons.ttf
// module id = u8q7
// module chunks = 4